import {
    ISubscriptionsData,
    ISubscriptionsEditableData,
} from "../subscriptionPreferences/SubscriptionPreferencesModel";

const isEqual = require("lodash/isEqual");

export function isSubscriptionFormDataChanged(
    oldData: ISubscriptionsEditableData,
    { generalConsents, subscriptions } = {} as ISubscriptionsData
) {
    const data: ISubscriptionsEditableData = { generalConsents, subscriptions };
    return !isEqual(oldData, data);
}
